import { DateTime } from "luxon";
import Range from "@/inside/models/Filter/Range";

/**
 * @property {DateTime|null} start
 * @property {DateTime|null} end
 */
export default class DateRange extends Range {
    /**
     * Returns a boolean indicating whether given `datetime` is included in this date range.
     * @param {DateTime} datetime
     * @return {boolean}
     */
    isIncluded(datetime) {
        if (!(datetime instanceof DateTime)) {
            throw new TypeError(`DateRange.isIncluded() method expects parameter 1 to be an instance of DateTime, ${typeof datetime} given`);
        }

        if (
            !(this.start instanceof DateTime)
            && !(this.end instanceof DateTime)
        ) {
            return true;
        }

        if (this.start instanceof DateTime) {
            if (this.end instanceof DateTime) {
                return (
                    datetime.valueOf() >= this.start.valueOf()
                    && datetime.valueOf() <= this.end.valueOf()
                );
            } else {
                return datetime.valueOf() >= this.start.valueOf();
            }
        }

        // All cases involving `DateRange.start` property are covered

        if (this.end instanceof DateTime) {
            return datetime.valueOf() <= this.end.valueOf();
        }
    }

    /**
     * Sets given `start` and given `end` as this date range new limits.
     * @param {null|DateTime} start
     * @param {null|DateTime} end
     * @return {DateRange}
     */
    set(start, end) {
        if (null !== start && !(start instanceof DateTime)) {
            throw new TypeError(`DateRange.set() method expects parameter 1 to be an instance of DateTime, ${typeof start} given`);
        }

        if (null !== end && !(end instanceof DateTime)) {
            throw new TypeError(`DateRange.set() method expects parameter 2 to be an instance of DateTime, ${typeof end} given`);
        }

        this.start = start;
        this.end = end;
        return this;
    }

    isEmpty() {
        return this.start === null && this.end === null;
    }
}
